import clsx from 'clsx';
import { useEffect, useState } from 'react';
import { DEFAULT_SUPPORT_EMAIL, getSupportEmail } from 'utils/supportInfo';
import Icon from 'components/UI/Icons/Icon';
import translate from 'translate';
import { LinkText } from 'components';
import { colors } from 'style/colors';
import { Button } from 'components/UI/new';
import styles from './styles.module.scss';

interface INoBookingsProps {
  isFullHeight?: boolean;
}

const NoBookings = ({ isFullHeight = false }: INoBookingsProps) => {
  const [supportEmail, setSupportEmail] = useState<string>(
    DEFAULT_SUPPORT_EMAIL
  );

  const handleClick = () => {
    window.open(process.env.REACT_APP_SEAWARE_TOUCH_ENDPOINT, '_blank');
  };

  useEffect(() => {
    getSupportEmail().then(setSupportEmail);
  }, []);

  return (
    <div
      className={clsx(styles.noResultRoot, {
        [styles.fullHeightRoot]: isFullHeight,
      })}
    >
      <Icon
        iconType="binocularAlternative"
        width={78}
        height={54}
        color={colors.hrx.caviar60}
        className={styles.icon}
      />
      <p className={styles.description}>
        {translate('MyBookingsList_NoActiveBookings')}
      </p>

      <div className={styles.card}>
        <div>
          <p className={styles.cardHeading}>
            {translate('MyBookingsList_NoActiveBookings_DontSeeYourBookings')}
          </p>
          <p className={styles.cardText}>
            {translate(
              'MyBookingsList_NoActiveBookings_YourBookingMayHaveBeenMigrated'
            )}
          </p>
          <p className={styles.cardText}>
            {translate(
              'MyBookingsList_NoActiveBookings_ConsultYourEmailsForUpdatedBookingID'
            )}
          </p>
        </div>
        <Button
          variant="primary"
          onClick={handleClick}
          icon="newTab"
          iconPosition="right"
        >
          {translate('MyBookingsList_SeawareCTA_Button')}
        </Button>
        <p className={styles.cardText}>
          {translate(
            'MyBookingsList_NoActiveBookings_StillCantSeeYourBooking',
            <LinkText href={`mailto:${supportEmail}`}>{supportEmail}</LinkText>
          )}
        </p>
      </div>
    </div>
  );
};

export default NoBookings;
